<template>
  <div class="nx-wizard-photogallery-step2-wrapper">
    <v-radio-group
      @change="onUseUsePhotoGalleryName"
      :value="usePhotoGalleryName"
      class="pl-3"
    >
      <v-radio
        :value="false"
        :label="$t('message.wizard.photoGallery.useIndividualImagesName')"
      ></v-radio>
      <v-radio
        :value="true"
        :label="$t('message.wizard.photoGallery.usePhotoGalleryName')"
      ></v-radio>
    </v-radio-group>
    <nx-sortable-list
      @input="onSortItem"
      :items="value.slice()"
      :disabled="disabled"
      :handle="'.drag'"
    >
      <template #precontent="{item, index}">
        <div class="nx-normal-list-img mr-2">
          <v-img
            :src="item.blobUrl"
            :alt="item.name"
            width="80"
            height="40"
          ></v-img>
        </div>
      </template>
      <template #content="{item, index}">
        <div style="width:100%; cursor:pointer">
          <v-text-field
            v-model="item.name"
            append-icon="edit"
            :disabled="usePhotoGalleryName"
          ></v-text-field>
        </div>
      </template>

      <template #action>
        <v-icon class="drag" style="cursor: grab">drag_handle</v-icon>
      </template>
    </nx-sortable-list>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import NxSortableList from '@/components/list/legacy/SortableList.vue';

export default {
  name: 'nx-wizard-photogallery-step2',
  extends: {},
  mixins: [],
  components: {
    NxSortableList,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    draft: {
      type: Object,
      default: () => ({}),
    },
    disabled: Boolean,
  },
  data() {
    return {
      usePhotoGalleryName: false,
      originalFiles: [],
    };
  },
  methods: {
    internalValue() {
      return cloneDeep(this.value);
    },
    update(internalValue) {
      this.$emit('input', internalValue);
    },
    onUseUsePhotoGalleryName(value) {
      const internalValue = this.internalValue();
      if (value) {
        this.usePhotoGalleryName = true;
        this.originalFiles = internalValue.map(file => file.name);
        internalValue.forEach((image) => {
          image.name = this.draft.title;
        });
      } else {
        this.usePhotoGalleryName = false;
        internalValue.forEach((image, index) => {
          image.name = this.originalFiles[index];
        });
      }
      this.update(internalValue);
    },
    onSortItem(evt) {
      const internalValue = this.internalValue();

      const { newIndex, oldIndex } = evt.moved;
      [internalValue[oldIndex], internalValue[newIndex]] = [internalValue[newIndex], internalValue[oldIndex]];
      // We also sort originalFiles in order to keep track of index changes
      // so if we sort the array in "use photogallery name" we keep the original name
      [this.originalFiles[oldIndex], this.originalFiles[newIndex]] = [
        this.originalFiles[newIndex],
        this.originalFiles[oldIndex],
      ];

      this.update(internalValue);
    },
  },
};
</script>
<style lang="stylus">
.nx-wizard-photogallery-step2-wrapper {
  .v-text-field {
    .v-input__append-inner {
      opacity: 0
      transition opacity .3s ease-in-out
    }

    &.v-text-field--is-focused,
    &:hover {
      .v-input__append-inner {
        opacity: 1
      }
    }
  }
}
</style>
